import { AppStateContext } from '../../state/AppProvider';
import { BotConversations, ChatHistoryLoadingState, historyEnsure, historyList } from '../../api';
import { useContext } from 'react';

const useChatHistory = () => {
  const appStateContext = useContext(AppStateContext);

  const fetchChatHistory = async (offset = 0): Promise<BotConversations[] | null> => {
    const userId = localStorage.getItem('userId');
    const email = localStorage.getItem('email');
    const accessToken = localStorage.getItem('accessToken');

    if(!accessToken){
      return null;
    }

    try{
      appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY_LOADING_STATE', payload: ChatHistoryLoadingState.Loading });

      const ensureResult = await historyEnsure(email!, userId!, accessToken!);
      appStateContext?.dispatch({ type: 'SET_COSMOSDB_STATUS', payload: ensureResult });
      
      // Only proceed if CosmosDB is available
      if (!ensureResult?.cosmosDB) {
        console.warn('[ChatHistoryService] CosmosDB not available:', ensureResult?.status);
        appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY_LOADING_STATE', payload: ChatHistoryLoadingState.Fail });
        appStateContext?.dispatch({ type: 'FETCH_CHAT_HISTORY', payload: null });
        return null;
      }
      
      const result = await historyList(offset, email!, userId!, accessToken!)
      if (result) {
        appStateContext?.dispatch({ type: 'FETCH_CHAT_HISTORY', payload: result });
        appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY_LOADING_STATE', payload: ChatHistoryLoadingState.Success });
      } else {
        appStateContext?.dispatch({ type: 'FETCH_CHAT_HISTORY', payload: null });
        appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY_LOADING_STATE', payload: ChatHistoryLoadingState.Fail });
      }
      return result;
    }catch(err){
      appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY_LOADING_STATE', payload: ChatHistoryLoadingState.Fail });
      appStateContext?.dispatch({ type: 'FETCH_CHAT_HISTORY', payload: null });
      console.error('There was an issue fetching your data.', err);
      return null;
    }
  };

  return { fetchChatHistory };
};

export default useChatHistory;
